import { useDispatch } from 'react-redux';
import { appendAlertItem, AlertType } from '@pruforce/common-adminweb-sdk';
import { downloadBase64File } from 'src/app/common/utils';
import {
  fetchChangeRequestDocument,
  fetchDocument,
  ViewChangeRequestDocumentParam,
} from '../../../../network/personalParticularCrud';

export const useDocument = () => {
  const dispatch = useDispatch();

  const handleOpenFile = async (fetcher: () => Promise<any>, filenameTranslation: string) => {
    try {
      const result = await fetcher();

      const fileBase64Str = result?.result?.fileBase64Str;

      if (!fileBase64Str) {
        dispatch(
          appendAlertItem([
            {
              severity: AlertType.ERROR,
              title: 'Error',
              content: `Document not found - ${filenameTranslation}`,
            },
          ]),
        );
        return;
      }

      downloadBase64File(fileBase64Str, 'application/pdf;base64');
    } catch (err) {
      console.error(err);
    }
  };

  const openFile = (appId: string, filename: string, filenameTranslation: string) =>
    handleOpenFile(() => fetchDocument(appId, { filename }, dispatch), filenameTranslation);

  const openChangeRequestFile = (params: ViewChangeRequestDocumentParam, filenameTranslation: string) =>
    handleOpenFile(() => fetchChangeRequestDocument(params, dispatch), filenameTranslation);

  return {
    openFile,
    openChangeRequestFile,
  };
};
